import { render, staticRenderFns } from "./ReqFarmacia.vue?vue&type=template&id=2a05d176&scoped=true"
import script from "./ReqFarmacia.vue?vue&type=script&lang=js"
export * from "./ReqFarmacia.vue?vue&type=script&lang=js"
import style0 from "./ReqFarmacia.vue?vue&type=style&index=0&id=2a05d176&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a05d176",
  null
  
)

export default component.exports